import { useEffect, useState, useRef, act } from 'react';
import axios from 'axios';

import { AuthStatus, useAuth } from '../auth';
import { useLocation, useNavigate } from "react-router-dom";

import { set, useForm } from "react-hook-form";
import { Modal, Popover } from 'bootstrap';


import { ToastContainer, toast } from 'react-toastify';

import Toggle from 'react-toggle';


import NavBar from './navbar';
import Menu   from './menu';

import '../styles/demmits.scss';


const endpoint = process.env.REACT_APP_ENDPOINT;

const Demmits = () => {

    // Datos generales
    const status = AuthStatus();
    const { token } = useAuth();
    const location = useLocation();

    const contractType = location.state?.new;
    const demmitTypes = [
        { value: 'voluntaria', label: "Renuncia Voluntaria"},
        { value: 'embarazo',   label: "Renunca Mujer Embarazada"},
        { value: 'convenio',   label: "Convenio de Terminación Laboral"},
        { value: 'finiquito',  label: "Recibo de Finiquito"},
    ];

    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
   
    const [collaborators, setCollaborators] = useState([]);
    const [filteredCollaborators, setFilteredCollaborators] = useState([]);
   
    // Campos de form
    const [selectedCollaborator, setSelectedCollaborator] = useState([]);
   
    const { register, setValue } = useForm();
    const demmitTitle = demmitTypes.find(type => type.value === contractType)?.label || "Mixto";

    const [calculatorData, setCalculatorData] = useState({
        perceptions: [],
        deductions: [],
        total: 0
    });

    const onSubmit = async (data) => {

    };

    // Obtener empresas
    const fetchCompanies = async () => {
        try {
            const response = await axios.get(`${endpoint}admin/companies`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setCompanies(response.data);
            console.log(response.data);
            if (response.data.length > 0 ) {
                setSelectedCompany(response.data[0]); // Selecciona la primera empresa solo si no hay contrato existente
            }
        } catch (error) {
            toast.error('Error al obtener la lista de compañías');
        }
    };

    // Obtener colaboradores
    const fetchCollaborators = async () => {
        try {
            const response = await axios.get(`${endpoint}admin/collaborators`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setCollaborators(response.data);
        } catch (error) {
            toast.error('Error al obtener la lista de colaboradores');
        }
    };

    // Filtrar colaboradores cuando cambia la empresa seleccionada
    useEffect(() => {
        if (selectedCompany) {
            const filtered = collaborators.filter(col => col.company_id === selectedCompany.id);
            setFilteredCollaborators(filtered);
        
          
            if(selectedCompany && contractType === "anticipo"){
                setValue('representante',selectedCompany.representante_legal)
                
            }
        }
    }, [selectedCompany, collaborators]);

    useEffect(() => {
        if(selectedCompany){
            if(selectedCompany.addresses.length > 0){
                let defaultAddress = selectedCompany.addresses[0]
                console.log(defaultAddress)
                setValue('lugar_trabajo',defaultAddress.calle + ' ' + defaultAddress.numero_exterior + ', ' + defaultAddress.colonia + ', ' + defaultAddress.ciudad + ', ' + defaultAddress.estado)
                setValue('domicilio_patron',defaultAddress.calle + ' ' + defaultAddress.numero_exterior + ', ' + defaultAddress.colonia + ', ' + defaultAddress.ciudad + ', ' + defaultAddress.estado)
                if(contractType === 'finiquito'){
                    setValue('lugar_pago', defaultAddress.ciudad + ', ' + defaultAddress.estado )
                }
            }
            setValue('representante_legal',selectedCompany.representante_legal)
            setValue('giro_actividad',selectedCompany.giro_actividad)
        
        }
    },[selectedCompany])



    //Obtener datos 
     useEffect(() => {
        fetchCompanies();
        fetchCollaborators();

        var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
        var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
            return new Popover(popoverTriggerEl, {
                trigger: 'focus' // Se cierra cuando el usuario hace clic fuera
            });
        });
    }, [token]);

    const handleSelectCollaborator = (id)=>{
        let collaborator = collaborators.filter(c => c.id === Number(id))

        if(collaborator.length > 0){
            setSelectedCollaborator(collaborator[0])
            
            setValue('nombre', collaborator[0].nombre + ' ' +  collaborator[0].apellidos)
            //console.log(collaborator[0])
        }else{
            console.info('No collab')
            console.info(collaborators)
        }
    }

    const handleCalculatorDataChange = (data) => {
        setCalculatorData(data);
    }

    const handleDiscard = ()=>{

    }

    const handleSubmit = async (e) => {
       // e.preventDefault();
    }




    return(
        <div className="demmits">
            <NavBar auth={status} companies={companies} selected={selectedCompany} set={setSelectedCompany} />
            <div className='demmits-row'>
                <Menu />
                <form className='demmits-wrapper' onSubmit={handleSubmit(onSubmit)}>
                    <ToastContainer />
                    <h2>{ demmitTitle }</h2>
                    <div className='demmits-controls'>
                        <button type='button' className='btn btn-secondary' onClick={handleDiscard}>
                            Descartar
                        </button>
                        <button type='submit' className='btn btn-primary'>
                            Guardar
                        </button>
                    </div>

                    <strong>Datos Generales</strong>
                    <div className="demmits-worker demmits-section">
                        <b>Quien termina la relación laboral?</b>
                        <div className="c-select">
                            <label htmlFor="collaborator-select">Colaborador</label>
                            <select
                                required
                                id="collaborator-select"
                                value={selectedCollaborator ? selectedCollaborator.id : ''}
                                onChange={(e) => handleSelectCollaborator(e.target.value)}
                            >
                                <option value="">Selecciona una opción</option>
                                {collaborators.map(collaborator => (
                                    <option key={collaborator.id} value={collaborator.id}>
                                        { collaborator.nombre } { collaborator.apellidos } 
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="c-input">
                            <label htmlFor="elaboracion">Nombre</label>
                            <input type="text" 
                                required
                                id='nombre'
                                minLength={3}
                                {...register("nombre", { required: "Especifica nombre." })} 
                            />
                        </div>



                        <b>Donde termina la relación laboral?</b>
                        <div className="c-group">
                            <div className="c-input">
                                <label htmlFor="ciudad">Ciudad</label>
                                <input type="text" 
                                    required
                                    id='ciudad'
                                    {...register("ciudad", { required: "Especifica ciudad." })} 
                                />
                            </div>
                            <div className="c-select">
                                <label htmlFor="representante">Estado</label>
                                <select id="estado"
                                    required
                                    id='estado' 
                                    {...register("estado", { required: "Especifica estado." })}
                                >
                                    <option value="">Selecciona una opción</option>
                                    <option value="Aguascalientes">Aguascalientes</option>
                                    <option value="Baja California">Baja California</option>
                                    <option value="Baja California Sur">Baja California Sur</option>
                                    <option value="Campeche">Campeche</option>
                                    <option value="Chiapas">Chiapas</option>
                                    <option value="Chihuahua">Chihuahua</option>
                                    <option value="Ciudad de México">Ciudad de México</option>
                                    <option value="Coahuila">Coahuila</option>
                                    <option value="Colima">Colima</option>
                                    <option value="Durango">Durango</option>
                                    <option value="Guanajuato">Guanajuato</option>
                                    <option value="Guerrero">Guerrero</option>
                                    <option value="Hidalgo">Hidalgo</option>
                                    <option value="Jalisco">Jalisco</option>
                                    <option value="México">México</option>
                                    <option value="Michoacán">Michoacán</option>
                                    <option value="Morelos">Morelos</option>
                                    <option value="Nayarit">Nayarit</option>
                                    <option value="Nuevo León">Nuevo León</option>
                                    <option value="Oaxaca">Oaxaca</option>
                                    <option value="Puebla">Puebla</option>
                                    <option value="Querétaro">Querétaro</option>
                                    <option value="Quintana Roo">Quintana Roo</option>
                                    <option value="San Luis Potosí">San Luis Potosí</option>
                                    <option value="Sinaloa">Sinaloa</option>
                                    <option value="Sonora">Sonora</option>
                                    <option value="Tabasco">Tabasco</option>
                                    <option value="Tamaulipas">Tamaulipas</option>
                                    <option value="Tlaxcala">Tlaxcala</option>
                                    <option value="Veracruz">Veracruz</option>
                                    <option value="Yucatán">Yucatán</option>
                                    <option value="Zacatecas">Zacatecas</option>
                                </select>
                            </div>
                        </div>
                        
                       
                    </div>


                    <strong>Datos de la Empresa/Patrón</strong>
                    <div className="demmits-section">
                        <div className="c-select">
                            <label htmlFor="companie-select">Empresa / Patrón</label>
                            
                            <p>{selectedCompany ? selectedCompany.nombre : '--'}</p>
                        </div>

                        {
                            contractType === "convenio" && 
                            <>

                                <div className="c-input">
                                    <label htmlFor="representante_legal">Representante Legal</label>
                                    <input type="text" 
                                        required
                                        id='representante_legal'
                                        {...register("representante_legal", { required: "Especifica representante." })} 
                                    />
                                </div>

                                <div className="c-input">
                                    <label htmlFor="giro_actividad">Giro o Actividad</label>
                                    <input type="text" 
                                        required
                                        id='giro_actividad'
                                        {...register("giro_actividad", { required: "Especifica Giro o Actividad." })} 
                                    />
                                </div>

                                <div className="c-input">
                                    <label htmlFor="domicilio_patron">Domicilio</label>
                                    <input type="text" 
                                        required
                                        id='domicilio_patron'
                                        {...register("domicilio_patron", { required: "Especifica domicilio." })} 
                                    />
                                </div>

                            </>
                        }
                    </div>

                    <strong>Condiciones de la Relación Laboral</strong>
                    <div className="demmits-general demmits-section">
                        

                        <div className="c-input">
                            <label htmlFor="elaboracion">Fecha de Inicio de la Relación Laboral</label>
                            <small>Recuerda que la <b>Fecha de Inicio</b>, deberá ser la misma <b>Fecha de Alta al IMSS</b>, en caso de inscripción al IMSS.</small>
                            <input type="date" 
                                required
                                id='inicio'
                                {...register("inicio", { required: "Especifica fecha." })} 
                            />
                        </div>

                        <div className="c-input">
                            <label htmlFor="salario">Salario Diario Bruto</label>
                            <small>Recuerda que el <b>Salario</b>, deberá ser el mimso reportado en su <b>Nómina</b> y al IMSS, en caso de inscripción al IMSS.</small>
                            <input type="number" 
                                required
                                id='salario'
                                {...register("salario", { required: "Especifica salario." })} 
                            />
                        </div>

                        <div className="c-input">
                            <label htmlFor="salario">Puesto</label>
                            <input type="text" 
                                required
                                id='puesto'
                                {...register("puesto", { required: "Especifica puesto." })} 
                            />
                        </div>

                        <div className="c-input">
                            <label htmlFor="lugar_trabajo">Lugar/Centro de Trabajo</label>
                            <input type="text" 
                                required
                                id='lugar_trabajo'
                                {...register("lugar_trabajo", { required: "Especifica lugar de trabajo." })} 
                            />
                        </div>

                       
                        

                    </div>

                    <strong>Datos de la Terminación Laboral</strong>
                    <div className="demmits-section">
                         <div className="c-input">
                            <label htmlFor="elaboracion">Ultimo Día Laborado</label>
                            <input type="date" 
                                required
                                id='fin'
                                {...register("fin", { required: "Especifica fecha." })} 
                            />
                        </div>
                    </div>

                    {
                        (contractType === 'convenio' || contractType === 'finiquito') && 
                        <>
                            <strong>Calculadora de Finiquito</strong>
                            <div className="demmits-section">
                                <Calculator onDataChange={handleCalculatorDataChange} initialData={calculatorData} />
                                <div className="c-input">
                                    <label htmlFor="elaboracion">Fecha de Pago</label>
                                    <input type="date" 
                                        required
                                        id='fecha_pago'
                                    
                                        {...register("fecha_pago", { required: "Especifica fecha." })} 
                                    />
                                </div>
                                {
                                    contractType === 'finiquito' &&
                                    <div className="c-input">
                                        <label htmlFor="lugar_pago">Lugar de pago</label>
                                        <input type="text" 
                                            required
                                            id='lugar_pago'
                                            placeholder='Ciudad, Estado'
                                            {...register("lugar_pago", { required: "Especifica lugar." })} 
                                        />
                                    </div>
                                }
                            </div>
                        </>
                    }


                    
                  
                   
                   

                    <button id='submit' className='btn btn-primary'>
                        Crear documento
                    </button>
                </form>
            </div>
        </div>
    );

};


const Calculator = ({ onDataChange, initialData = null }) => {
    const [perceptions, setPerceptions] = useState([]);
    const [deductions, setDeductions] = useState([]);
    
    // Estados temporales para nuevos items
    const [tempPerception, setTempPerception] = useState({ concepto: '', base: '', monto: '' });
    const [tempDeduction, setTempDeduction] = useState({ concepto: '', monto: '' });

    // Cargar datos iniciales
    useEffect(() => {
        if (initialData) {
            if (initialData.perceptions) setPerceptions(initialData.perceptions);
            if (initialData.deductions) setDeductions(initialData.deductions);
        }
    }, [initialData]);

    // Calcular y enviar datos
    useEffect(() => {
        const totalPercepciones = perceptions.reduce((sum, p) => sum + (parseFloat(p.monto) || 0), 0);
        const totalDeducciones = deductions.reduce((sum, d) => sum + (parseFloat(d.monto) || 0), 0);
        
        onDataChange({
            percepciones: perceptions,
            deducciones: deductions,
            total_percepciones: totalPercepciones,
            total_deducciones: totalDeducciones,
            total: totalPercepciones - totalDeducciones
        });
    }, [perceptions, deductions]);

    const agregarPercepcion = () => {
        if (!tempPerception.concepto || !tempPerception.base || !tempPerception.monto) {
            toast.warn('Completa todos los campos');
            return;
        }
        
        setPerceptions([...perceptions, { ...tempPerception }]);
        setTempPerception({ concepto: '', base: '', monto: '' });
    };

    const agregarDeduccion = () => {
        if (!tempDeduction.concepto || !tempDeduction.monto) {
            toast.warn('Completa todos los campos');
            return;
        }
        
        setDeductions([...deductions, { ...tempDeduction }]);
        setTempDeduction({ concepto: '', monto: '' });
    };

    const eliminarPercepcion = (index) => {
        const nuevas = [...perceptions];
        nuevas.splice(index, 1);
        setPerceptions(nuevas);
    };

    const eliminarDeduccion = (index) => {
        const nuevas = [...deductions];
        nuevas.splice(index, 1);
        setDeductions(nuevas);
    };

    const totalPercepciones = perceptions.reduce((sum, p) => sum + (parseFloat(p.monto) || 0), 0);
    const totalDeducciones = deductions.reduce((sum, d) => sum + (parseFloat(d.monto) || 0), 0);

    return (
        <div className="demmits-calc">
            {/* Percepciones */}
            <div className="demmits-calc-section">
                <label>Percepciones</label>
                <div className="demmits-calc-row">
                    <input 
                        type="text" 
                        placeholder="Concepto"
                        value={tempPerception.concepto}
                        onChange={(e) => setTempPerception({...tempPerception, concepto: e.target.value})}
                    />
                    <input 
                        type="text" 
                        placeholder="Base"
                        value={tempPerception.base}
                        onChange={(e) => setTempPerception({...tempPerception, base: e.target.value})}
                    />
                    <input 
                        type="number" 
                        placeholder="Monto"
                        value={tempPerception.monto}
                        onChange={(e) => setTempPerception({...tempPerception, monto: e.target.value})}
                    />
                    <button type="button" onClick={agregarPercepcion}>+</button>
                </div>
                
                {perceptions.map((p, i) => (
                    <div key={i} className="demmits-calc-item">
                        <span>{p.concepto}</span>
                        <span>{p.base}</span>
                        <span className='-money'>${parseFloat(p.monto).toFixed(2)}</span>
                        <button type="button" onClick={() => eliminarPercepcion(i)}>x</button>
                    </div>
                ))}
            </div>

            {/* Deducciones */}
            <div className="demmits-calc-section">
                <label>Deducciones</label>
                <div className="demmits-calc-row">
                    <input 
                        type="text" 
                        placeholder="Concepto"
                        value={tempDeduction.concepto}
                        onChange={(e) => setTempDeduction({...tempDeduction, concepto: e.target.value})}
                    />
                    <input 
                        type="number" 
                        placeholder="Monto"
                        value={tempDeduction.monto}
                        onChange={(e) => setTempDeduction({...tempDeduction, monto: e.target.value})}
                    />
                    <button type="button" onClick={agregarDeduccion}>+</button>
                </div>
                
                {deductions.map((d, i) => (
                    <div key={i} className="demmits-calc-item -min">
                        <span>{d.concepto}</span>
                        <span className='-money'>${parseFloat(d.monto).toFixed(2)}</span>
                        <button type="button" onClick={() => eliminarDeduccion(i)}>x</button>
                    </div>
                ))}
            </div>

            {/* Totales */}
            <div className="demmits-calc-total">
                <div>Total Percepciones: ${totalPercepciones.toFixed(2)}</div>
                <div>Total Deducciones: ${totalDeducciones.toFixed(2)}</div>
                <div className="neto">Total Neto: ${(totalPercepciones - totalDeducciones).toFixed(2)}</div>
            </div>
        </div>
    );
};
export default Demmits;


